import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { StationUtils } from '../shared';
import { Invitation, InvitationResponseOptions } from '../shared/owner-transfer/invitation.model';
import { OwnershipTransferService } from '../shared/owner-transfer/owner-transfer.services';

@Component({
    selector: 'ag-ownership-transfer',
    templateUrl: './ownership-transfer.component.html',
    styleUrls: ['./ownership-transfer.component.scss'],
    standalone: false
})
export class OwnershipTransferComponent implements OnInit 
{
    invitationId: string
    invitation: Invitation
    stationAddress: string
    shouldDeleteGuests = false
    keepCurrentOwner = false

    constructor(private route: ActivatedRoute, 
                private router: Router, 
                private translateService: TranslateService,
                private ownershipTransferService: OwnershipTransferService)
    {
    }

    ngOnInit() 
    {
        this.route.queryParams.subscribe(params => 
        {
            if(params.lang)
            {
                this.translateService.use(params.lang)
            }
        });

        this.route.params.subscribe(params =>
            {
                this.invitationId = params['invitationId']
    
                this.ownershipTransferService.getInvitation(this.invitationId).subscribe(invitation => 
                {
                    this.invitation = invitation
                    this.stationAddress = StationUtils.getAddressStringFromAddress(invitation.station.address)
                }, 
                error =>
                {
                    this.onError(error);
                })
            })
    }

    onAcceptInvitation()
    {
        const options: InvitationResponseOptions = 
        {
            resetWhitelist: this.shouldDeleteGuests,
            keepCurrentOwner: this.keepCurrentOwner

        }
        this.ownershipTransferService.acceptInvitation(this.invitationId, options).subscribe(() => 
        {
            this.router.navigate(['invite/accepted/'], { queryParams: { stationName: this.invitation.station.name, currentOwnerName: this.invitation.currentOwner.name }});
        }, 
        error =>
        {
            this.onError(error);
        })
    }

    onDeclineInvitation()
    {

        this.ownershipTransferService.declineInvitation(this.invitationId).subscribe(() => 
        {
            this.router.navigate(['invite/declined/'], { queryParams: { stationName: this.invitation.station.name, currentOwnerName: this.invitation.currentOwner.name }});
        }, 
        error =>
        {
            this.onError(error);
        })
    }

    onError(error)
    {
        const errorMessage = JSON.parse(error.message);
        this.router.navigate(['invite/error/'], { queryParams: { errorMessage: errorMessage.error.errorDescription }});
    }

    onDeleteGuestChange(event)
    {
        this.shouldDeleteGuests = event.target.checked
    }

    onKeepOwnerChange(event)
    {
        this.keepCurrentOwner = event.target.checked
    }
}
